import { Button, Modal, QuestionnaireMarkdown } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { encounterRoutes } from '../../encounters/encounter-routes';

type TreatmentChangedModalProps = {
  open: boolean;
};

export const TreatmentChangedModal = ({ open }: TreatmentChangedModalProps) => {
  const { t } = useTranslation('treatments', {
    keyPrefix: 'PrepTreatment.StopAdvisory',
  });
  const navigate = useNavigate();

  // The plan change is already saved by the time this opens, so dismissing via
  // the X or Esc must land somewhere sensible rather than read as a cancel.
  const handleDismiss = () => navigate('/');

  return (
    <Modal.Root open={open} onOpenChange={handleDismiss}>
      <Modal.Content title={t('Title')} aria-label={t('Title')}>
        <Modal.Body>
          <QuestionnaireMarkdown>{t('Body')}</QuestionnaireMarkdown>
        </Modal.Body>
        <Modal.Actions>
          <Button
            intent="secondary"
            width="full"
            onClick={() => navigate(encounterRoutes.newAppointment.build())}
          >
            {t('BookConsult')}
          </Button>
          <Button width="full" onClick={handleDismiss}>
            {t('Continue')}
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal.Root>
  );
};
